export default __webpack_public_path__ + "static/media/bg-2500.293a19bc.jpeg";